"use client";

import { useLocale, useTranslations } from 'next-intl';
import Image from "next/image";
import Button from '../Button/Button';

const BOOK_COVERS = {
  en: {
    ai: [
      { id: 1, imageUrl: "/images/cover1_ai.avif" },
      { id: 2, imageUrl: "/images/cover2_ai.avif" },
      { id: 3, imageUrl: "/images/cover3_ai.avif" },
      { id: 4, imageUrl: "/images/cover4_ai.avif" },
    ],
    regular: [
      { id: 1, imageUrl: "/images/cover1.webp" },
      { id: 2, imageUrl: "/images/cover2.webp" },
      { id: 3, imageUrl: "/images/cover3.webp" },
      { id: 4, imageUrl: "/images/cover4.webp" },
      { id: 5, imageUrl: "/images/cover5.webp" },
      { id: 6, imageUrl: "/images/cover6.webp" },
      { id: 7, imageUrl: "/images/cover7.webp" },
      { id: 8, imageUrl: "/images/cover8.webp" }
    ]
  },

  "es-us": {
    ai: [
      { id: 1, imageUrl: "/images/es-us/cover1_ai.avif" },
      { id: 2, imageUrl: "/images/es-us/cover2_ai.avif" },
      { id: 3, imageUrl: "/images/es-us/cover3_ai.avif" },
      { id: 4, imageUrl: "/images/es-us/cover4_ai.avif" },
    ],
    regular: [
      { id: 1, imageUrl: "/images/es-us/cover1.webp" },
      { id: 2, imageUrl: "/images/es-us/cover2.webp" },
      { id: 3, imageUrl: "/images/es-us/cover3.webp" },
      { id: 4, imageUrl: "/images/es-us/cover4.webp" },
      { id: 5, imageUrl: "/images/es-us/cover5.webp" },
      { id: 6, imageUrl: "/images/es-us/cover6.webp" },
      { id: 7, imageUrl: "/images/es-us/cover7.webp" },
      { id: 8, imageUrl: "/images/es-us/cover8.webp" }
    ]
  }
};

const BookCovers = () => {
  const t = useTranslations('home.bookCovers');
  const locale = useLocale();


  const covers = BOOK_COVERS[locale] || BOOK_COVERS.en;
  const slidesAi = covers.ai;
  const slides = covers.regular;

  const renderSlide = (slide, index) => (
    <div className="w-full" key={slide.id}>
      <div className="relative md:h-[235px] md:w-[180px] w-[145px] h-[180px]">
        <Image
          src={slide.imageUrl}
          fill
          className="object-contain"
          sizes="(max-width: 768px) 145px, 220px"
          alt={`AI-generated book cover design ${index + 1}`}
          loading="lazy"
        />
      </div>
    </div>
  );

  const title = t('title');
  const subtitleAi = t.raw('subtitleAi');
  const subtitle = t.raw('subtitle');
  const button = t('button');

  return (
    <section className="bg-pink text-white section-py" id='book-covers'>
      <div className="max-w-[940px] mx-auto px-4">
        <div className="flex">
          <div className="w-full">
            <h2 className="text-title text-center">
              {title}
            </h2>
            <p className="text-gray text-center font-medium  text-[19px] leading-[24px] mt-8 ">
              {subtitleAi}
            </p>
          </div>
        </div>

        <div className="mx-auto w-full mt-7  overflow-x-scroll no-scrollbar">
          <div className="grid grid-rows-1 grid-cols-[repeat(4,145px)] md:grid-cols-[repeat(4,180px)] md:gap-x-3 gap-y-3 md:gap-y-8 865:justify-center">
            {slidesAi.map(renderSlide)}
          </div>
        </div>
        <div className="mt-11">
          <p className="text-gray text-center font-medium  text-[19px] leading-[24px] ">
            {subtitle}
          </p>
        </div>
        <div className="mx-auto w-full mt-7  overflow-x-scroll no-scrollbar">
          <div className="grid grid-rows-2 grid-cols-[repeat(4,145px)] md:grid-cols-[repeat(4,180px)] md:gap-x-3 gap-y-3 md:gap-y-8 865:justify-center">
            {slides.map(renderSlide)}
          </div>
        </div>

        <div className="hidden md:block">
          <Button text={button} />
        </div>
      </div>
    </section>
  );
};

export default BookCovers;